import { Box, CircularProgress } from '@material-ui/core';
import { ExternalIdType, getPaymentAttemptsByExternalId } from '@nemuru-eng/js-api-client';

import { PaymentAttempts } from '@/components/modules/PaymentAttempts/shared/PaymentAttempts';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { PendingDataType } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';

interface PaymentPlanLinePaymentAttemptsProps {
  paymentPlanLineId: string;
}

export const PaymentPlanLinePaymentAttempts = ({ paymentPlanLineId }: PaymentPlanLinePaymentAttemptsProps) => {
  const { data: paymentAttempts, loading } = useCache(getPaymentAttemptsByExternalId, {
    externalId: paymentPlanLineId,
    type: ExternalIdType.PAYMENT_PLAN_LINE,
  });

  if (loading) {
    return (
      <Box width={'100%'} pt={2} display={'flex'} justifyContent={'center'}>
        <CircularProgress size={60} thickness={2} color={'secondary'} />
      </Box>
    );
  }

  return (
    <>
      <div className={'appear-anim'}>
        {paymentAttempts ? (
          <PaymentAttempts paymentAttempts={paymentAttempts} />
        ) : (
          <PendingDataWarning type={PendingDataType.PAYMENT_ATTEMPTS} />
        )}
      </div>
    </>
  );
};
